import ErrorText from "@/components/ui/auth/ErrorText";
import ExtendedDefaultSelect from "@/components/ui/inputs/select/ExtendedDefaultSelect";
import { Box } from "@chakra-ui/react";

const directions = [
  { id: 1, title: "Sort A→Z", key: "asc" },
  { id: 2, title: "Sort Z→A", key: "desc" },
];

const SortDirectionSelect = ({ control, errors }) => {
  return (
    <Box pos={"relative"}>
      <ExtendedDefaultSelect
        {...{
          control,
          name: `direction`,
          customSelectStyle: {
            control: {
              boxShadow: "none",
              borderColor: "lightGray",
              maxHeight: "32px",
              width: "132px",
              borderRadius: "3px",
              bg: "white",
              "&:hover": {
                boxShadow: "none",
                borderColor: "grey",
                outline: "none",
                outlineOffset: "0",
              },
              "&:active": {
                borderColor: "lightGray",
              },
              "&:focus": {
                borderColor: "lightGray",
              },
            },
            placeholder: {
              textAlign: "start",
            },
            dropdownIndicator: {
              color: "grey",
            },

            menuList: {
              "::-webkit-scrollbar": { width: "4px", height: "4px" },
              "::-webkit-scrollbar-thumb": {
                backgroundColor: "#7e869e",
                borderRadius: "7px",
              },
              "::-webkit-scrollbar-track": {
                backgroundColor: "#f0f2f5",
              },
            },
            valueContainer: {
              padding: "8px 12px",
            },
            singleValue: {
              textAlign: "start",
              fontSize: "12px",
              letterSpacing: "4%",
              lineHeight: "1",
              fontWeight: "400",
            },
            option: {
              fontSize: "12px",
            },
            input: {
              fontSize: "12px",
            },
          },
          options: directions?.map((item) => ({
            label: item?.title,
            value: item?.key,
          })),
        }}
      />
      {errors?.direction?.message ? (
        <ErrorText
          title={errors?.direction?.message}
          error_style={{ bottom: "-12px" }}
        />
      ) : null}
    </Box>
  );
};

export default SortDirectionSelect;
